export enum eReservetype {
    Partidos= 1,
    Recurrentes = 2,
    Torneos = 3,
    Eventos_Empresariales = 4,
    Cumpleaños = 5,
    Academias = 6,
    Otros = 7
}